import {
  Phone,
  Mail,
  Instagram,
  MessageSquare,
  Globe,
  MessageCircle,
  Linkedin,
} from 'lucide-react';
import { CommunicationMethod } from '../types';

export function getCommIcon(type: string, size: number = 18) {
  switch (type.toLowerCase()) {
    case 'phone':
      return <Phone size={size} />;
    case 'email':
      return <Mail size={size} />;
    case 'instagram':
      return <Instagram size={size} />;
    case 'whatsapp':
      return <MessageSquare size={size} />;
    case 'messenger':
      return <MessageCircle size={size} />;
    case 'linkedin':
      return <Linkedin size={size} />;
    case 'twitter':
      return <Globe size={size} />;
    default:
      return <MessageCircle size={size} />;
  }
}

export function getCommHref(method: CommunicationMethod, action?: 'call' | 'sms'): string {
  const value = method.value.replace(/\s+/g, '');
  switch (method.type.toLowerCase()) {
    case 'phone': {
      const digits = value.replace(/\D/g, '');
      return action === 'sms' ? `sms:${digits}` : `tel:${digits}`;
    }
    case 'email':
      return `mailto:${value}`;
    case 'whatsapp':
      return `https://wa.me/${value.replace(/\D/g, '')}`;
    case 'instagram':
      return `https://instagram.com/${value.replace('@', '')}`;
    case 'messenger':
      return `https://m.me/${value.replace('@', '')}`;
    case 'linkedin': {
      // Handle both full URLs and usernames
      if (value.includes('linkedin.com'))
        return value.startsWith('http') ? value : `https://${value}`;
      return `https://linkedin.com/in/${value.replace('@', '')}`;
    }
    case 'twitter': {
      const handle = value.replace('@', '');
      return `https://x.com/${handle}`;
    }
    default:
      return value.startsWith('http') ? value : `https://${value}`;
  }
}
